import variables from './variables';

export { variables };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-style-const/es/index.js
// module id = 295
// module chunks = 0